module.exports = __webpack_public_path__ + "static/media/selectArrowDown.06f5990c.svg";